/**
 * Created by Maria on 27/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('regions', {
                parent: 'masterData',
                url: '/regions',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/regions/regions.html',
                        controller: 'MDRegionsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();



